import { useMemo } from 'react';
import { PropertyStatusOptions } from '~graphql/__generated__/globalTypes';

export const PropertyOfflineStatus = [
  PropertyStatusOptions.INVALID_DATA,
  PropertyStatusOptions.OFFBOARDED,
];

export function usePropertyIsOffline(status: PropertyStatusOptions | undefined): boolean {
  return useMemo(() => {
    return status ? PropertyOfflineStatus.includes(status) : false;
  }, [status]);
}
